import { Component, OnInit } from '@angular/core';
import { LoadingIndicatorService } from 'src/app/data/services/loading-indicator.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.styles.scss']
})
export class PageNotFoundComponent implements OnInit {
  public readonly _link = environment.supportLink;

  constructor(private _loader: LoadingIndicatorService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this._loader.hide();
    }, 1000);
  }
}

